
import Hero from "../../components/Loan";
import VehicleDetails from "../../components/VehicleDetails";



const Home = () => {


  return (
    <>
      <Hero />
      <VehicleDetails/>
    </>
  );
};

export default Home;
